import { Routes } from '@angular/router';

import { HomeComponent } from './pages/home/home';
import { DashboardComponent } from './pages/dashboard/dashboard';
import { OverviewComponent } from './pages/overview/overview';
import { AlertsComponent } from './pages/alerts/alerts';
import { MaritimeComponent } from './pages/maritime/maritime';
import { CyberComponent } from './pages/cyber/cyber';
import { IncidentsComponent } from './pages/incidents/incidents';
import { AdministrationComponent } from './pages/administration/administration';
import { rolesGuard } from './security/roles.guard';
import { APP_ROLES } from './security/roles';


export const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'overview', component: OverviewComponent },
  { path: 'alerts', component: AlertsComponent, canActivate: [rolesGuard([APP_ROLES.ANALYST, APP_ROLES.OPERATOR])] },
  { path: 'maritime', component: MaritimeComponent },
  { path: 'cyber', component: CyberComponent, canActivate: [rolesGuard([APP_ROLES.ANALYST, APP_ROLES.OPERATOR])] },
  { path: 'incidents', component: IncidentsComponent, canActivate: [rolesGuard([APP_ROLES.ANALYST, APP_ROLES.OPERATOR])] },
  { path: 'administration', component: AdministrationComponent, canActivate: [rolesGuard([APP_ROLES.ADMIN])] },
  { path: '**', redirectTo: '' },
];
